import React from "react";
// mui
import {
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Grid,
  Box,
} from "@mui/material";

export const RecentActivity = () => {
  const Trend = "/Assets/Icons/trend.svg";

  const rawData = [
    {
      id: 1,
      name: "Approved recharge request from player_one",
      value: "Jan 19, 2025",
    },
    {
      id: 2,
      name: "Suspended account for player_three",
      value: "Jan 20, 2025",
    },
    {
      id: 3,
      name: "Updated system settings",
      value: "Jan 21, 2025",
    },
    {
      id: 4,
      name: "Changed password",
      value: "Jan 22, 2025",
    },
  ];

  return (
    <React.Fragment>
      <Card
        variant="outlined"
        sx={{
          mb: 2,
          backgroundColor: "#242424",
          borderRadius: "8px",
        }}
      >
        <CardActionArea>
          <CardContent>
            <Typography
              variant="body2"
              sx={{
                color: "#FFF",
                fontSize: 18,
                fontWeight: 400,
              }}
            >
              Recent Activity
            </Typography>

            <Grid container spacing={2}>
              {rawData?.map((ele, index) => (
                <Grid item xs={12} sm={12} md={12} key={ele?.id}>
                  <Card
                    variant="outlined"
                    sx={{
                      mt: 1,
                      border: "1px solid #1A1A1A",
                      background: "#1A1A1A",
                    }}
                  >
                    <CardActionArea>
                      <CardContent>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={Trend}
                            alt={index + 1}
                            style={{ width: 18, height: 18 }}
                          />
                          <Box
                            sx={{
                              ml: 1,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#999",
                                fontSize: 14,
                                fontWeight: 400,
                              }}
                            >
                              {ele?.name}
                            </Typography>

                            <Typography
                              variant="body2"
                              sx={{
                                color: "#FFF",
                                fontSize: 14,
                                fontWeight: 400,
                              }}
                            >
                              {ele?.value}
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </CardActionArea>
      </Card>
    </React.Fragment>
  );
};
